import { get, map } from 'lodash/fp';
import PropTypes from 'prop-types';
import { SelectPicker } from 'rsuite';
import React, { Fragment, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInventoryAvailabilityOptions } from '../../redux/sagas/routines';
import { getAvailabilityOptions } from '../../redux/Inventory/selectors/options/availability';

const InventoryAvailabilitySelectPicker = ({
  placeholder,
  groupBy,
  ...props
}) => {
  const dispatch = useDispatch();
  const availabilityOptions = useSelector(getAvailabilityOptions);
  const availabilityGroupedOptions = useMemo(
    () =>
      map(
        option => ({ ...option, group: get(groupBy, option) }),
        availabilityOptions
      ),
    [availabilityOptions]
  );
  useEffect(() => {
    dispatch(fetchInventoryAvailabilityOptions());
  }, []);

  const renderMenuItem = (label, item) => {
    const zoneName = get('meta.zone.name', item);
    return (
      <Fragment>
        <p>
          <strong>{label}</strong>
        </p>
        <em>
          {get('meta.location.name', item)}
          {zoneName ? `, ${zoneName}` : ''}
        </em>
      </Fragment>
    );
  };

  const renderValue = (_, item) =>
    !item ? (
      placeholder
    ) : (
      <Fragment>
        <span>{get('label', item)}</span>
        <em>{` - ${get('meta.location.name', item)}`}</em>
      </Fragment>
    );

  return (
    <SelectPicker
      {...props}
      groupBy="group"
      data={availabilityGroupedOptions}
      renderMenuItem={renderMenuItem}
      renderValue={renderValue}
      virtualized={false}
    />
  );
};

InventoryAvailabilitySelectPicker.propTypes = {
  placeholder: PropTypes.string,
  groupBy: PropTypes.string // supports path key Prop
};

InventoryAvailabilitySelectPicker.defaultProps = {
  placeholder: 'Select',
  groupBy: 'meta.group'
};

export default InventoryAvailabilitySelectPicker;
